import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ContractOrderOutputDto } from '@api/client';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { clOrderSfDetailSelector } from '../../_redux/selectors';
import { resetClOrderDetail, searchClOrderSfDetail } from '../../_redux/actions';
import AppCard from 'shared/design-system/components/app-card';
import NoData from 'shared/design-system/components/no-data-box';
import ClOrderData from './_components/cl-order-data';

const ClOrderDetail: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const [currentOrder, setCurrentOrder] = useState<ContractOrderOutputDto | undefined>(undefined);
  const orderSfDetail = useAppSelector(clOrderSfDetailSelector);

  useEffect(() => {
    return () => {
      dispatch(resetClOrderDetail());
    };
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(searchClOrderSfDetail({
        contractOrderSFSearchInputDto: { orderId: id, paging: { page: 0, size: 1 } }
      }));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (orderSfDetail?.contractOrderOutputDtoList?.length) {
      setCurrentOrder(orderSfDetail.contractOrderOutputDtoList[0]);
    }
  }, [orderSfDetail]);

  return (
    <>
      <h4 className="text-gray-800 my-0">{t('Order')}</h4>

      {!currentOrder && (
        <AppCard title={t('Order data')} className="border-left-primary mt-3">
          <div className="mt-3">
            <NoData msg={t('No order found')} />
          </div>
        </AppCard>
      )}

      {currentOrder && (
        <>
          <ClOrderData order={currentOrder} />
        </>
      )}
    </>
  );
};

export default ClOrderDetail;
